import * as React from "react";
import { MaxLengthMessage } from "../Common/MaxLenghtMessage";
import { IInputFieldProps } from "../IInputFieldProps";

export interface TextAreaInputFieldProps extends IInputFieldProps<HTMLTextAreaElement> {
  autoFocus?: boolean;
  maxLength?: number;
  showCounterAndMaxLengthMessage?: boolean;
  inputRef?: React.RefCallback<HTMLTextAreaElement>;
}

export const TextareaInputField = (props: TextAreaInputFieldProps) => {
  return (
    <>
      <textarea
        {...props.input}
        className={`form-control form-control--textarea ${props.className ?? ""}`}
        style={{ display: props.displayStyle }}
        ref={props.inputRef}
        {...(props.id ? { id: props.id } : {})}
        {...(props.name ? { name: props.name } : {})}
        placeholder={props.placeholder}
        value={props.value || ""}
        onChange={props.onChange}
        onBlur={props.onBlur}
        maxLength={props.maxLength}
        rows={3}
        autoFocus={props.autoFocus}
        onFocus={function (e) {
          e.target.setSelectionRange(e.target.value.length, e.target.value.length);
        }}
      />
      {props.showCounterAndMaxLengthMessage && props.maxLength && (
        <MaxLengthMessage id={props.id} value={props.value} maxLength={props.maxLength} />
      )}
    </>
  );
};
